import setupOffer from '@/api/website/setup-offer'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  products: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_PRODUCTS(state, data) {
    state.products = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attributes
    )
    return setupOffer.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return setupOffer.store(data)
  },

  update(context, { id, data }) {
    return setupOffer.update(id, data)
  },

  destroy(context, id) {
    return setupOffer.destroy(id)
  },

  async getProduct(context, attributes = {}) {
    let response = await setupOffer.product({
      params: attributes
    })
    context.commit('SET_PRODUCTS', response.data)
  }
}
